let dotnetHelper;

function initializeDotNetHelper(helper) {
    dotnetHelper = helper;
}

function DumpLog() {
    if (!dotnetHelper) {
        console.error('dotnetHelper is undefined');
        return;
    }

    if (typeof dotnetHelper.invokeMethodAsync !== 'function') {
        console.error('invokeMethodAsync is not a function on dotnetHelper');
        return;
    }

    dotnetHelper.invokeMethodAsync('DumpLog');
}